import { useCallback } from 'react'
import { useDeleteNotificationsMutation } from '../api'

export const useDeleteNotifications = () => {
  const [deleteMutation, { loading }] = useDeleteNotificationsMutation()

  const deleteNotifications = useCallback(
    async (notificationIds: string[]) => {
      try {
        const result = await deleteMutation({
          variables: {
            notificationIds,
          },
        })

        return result.data?.notificationsDelete?.success ?? false
      } catch {
        return false
      }
    },
    [deleteMutation]
  )

  return {
    deleteNotifications,
    loading,
  }
}
